module.exports = __webpack_public_path__ + "img/prt00001a2.prt.9e820c19.jpg";